import Vue from 'vue';
import 'libs/startup.js';
import VueI18n from 'vue-i18n';
import Notifications from './Notifications/Notifications.vue';
import BasketDropDown from './BasketDropDown.vue';
import MoveBasketDropDown from './MoveBasketDropDown.vue';
import VerificationCode from './VerificationCode.vue';
import langDa from '../resources/da/notifications.json';
import langDe from '../resources/de/notifications.json';
import langEn from '../resources/en/notifications.json';
import langEs from '../resources/es/notifications.json';
import langFr from '../resources/fr/notifications.json';
import langPl from '../resources/pl/notifications.json';
import langTr from '../resources/tr/notifications.json';
import langZh from '../resources/zh/notifications.json';
import langNL from '../resources/notifications.json';

import { customTranslationsPlugin } from '../localizehelpers';

export const translations = {
  en: langEn,
  nl: langNL,
  de: langDe,
  pl: langPl,
  es: langEs,
  fr: langFr,
  tr: langTr,
  zh: langZh,
  da: langDa
};

const i18n = customTranslationsPlugin(translations);

Vue.use(VueI18n);

const create = (elementSelector) => {
  return new Vue({
    i18n: i18n,
    el: elementSelector,
    components: {
      'App': Notifications,
    },
    data () {
      return {};
    },
    template: `<App />`,
    methods: {
    }
  });
};

const basket = (elementSelector) => {
  return new Vue({
    i18n: i18n,
    el: elementSelector,
    components: {
      'App': BasketDropDown,
    },
    data () {
      return {};
    },
    template: `<App />`,
    methods: {
    }
  });
};

const movebasket = (elementSelector) => {
  return new Vue({
    i18n: i18n,
    el: elementSelector,
    components: {
      'App': MoveBasketDropDown,
    },
    data () {
      return {};
    },
    template: `<App />`,
    methods: {
    }
  });
};

const verificationCode = (elementSelector, code) => {
  return new Vue({
    i18n: i18n,
    el: elementSelector,
    components: {
      'App': VerificationCode,
    },
    data() {
      return { 
        code: code,
        count: 0
      };
    },
    template: `<App ref="verificationCode"/>`,
    methods: {
      showVerificationModal() {
        this.count++;
        if (this.count > 4) {
          this.$refs.verificationCode.showModal(this.code);
        }
      },
    }
  });
};

export const setup = () => {
  const instance = create('#vueNotification');
  const instance2 = basket('#vueBasket');
  const instance3 = movebasket('#vueMoveBasket');
  return instance;
};

export const setupVerificationCode = (code) => {
  return verificationCode('#vueVerificationCode', code);
};

window.initNotifications = setup;
window.initVerificationCode = setupVerificationCode;